const actions = {
  SET_STATE: "channel/SET_STATE",
  LIST: "channel/LIST",
  LIST_SHORT: "channel/LIST_SHORT",
  CREATE: "channel/CREATE",
  DETAIL: "channel/DETAIL",
  UPDATE: "channel/UPDATE",
  DELETE: "channel/DELETE",
};

export default actions;
